const initTechnicalCardsToggle = () => {
    const wrapper = document.querySelector('[data-technical-cards]');
    if (!wrapper) return;

    const cards = Array.from(wrapper.querySelectorAll('.TechnicalCards__item'));
    const toggle = wrapper.querySelector('[data-technical-toggle]');

    // Only apply on mobile
    const isMobile = () => window.innerWidth < 1024;

    const applyState = (expanded) => {
        cards.forEach((card, index) => {
            if (!isMobile()) {
                card.classList.remove('is-hidden');
                return;
            }
            if (index > 2 && !expanded) {
                card.classList.add('is-hidden');
            } else {
                card.classList.remove('is-hidden');
            }
        });

        if (toggle) {
            const labelCollapsed = toggle.querySelector('[data-toggle-label-collapsed]');
            const labelExpanded = toggle.querySelector('[data-toggle-label-expanded]');

            labelCollapsed?.classList.toggle('hidden', expanded);
            labelExpanded?.classList.toggle('hidden', !expanded);
        }
    };

    let expanded = false;
    applyState(expanded);

    toggle?.addEventListener('click', () => {
        expanded = !expanded;
        applyState(expanded);
    });

    window.addEventListener('resize', () => {
        applyState(expanded);
    });
};

document.addEventListener('DOMContentLoaded', initTechnicalCardsToggle);
